module.exports = __webpack_public_path__ + "img/dollar.502adfb4.svg";